import { useEffect, useState } from 'react'

/**
 * 페이지 주소의 id 가져오는 hook
 * @param index url split해서 가져올 index
 * @returns number | undefined
 */
function useParamId(index?: number) {
  const [paramId, setParamId] = useState<number | undefined>()

  const handleParamId = () => {
    const popId = typeof index === 'number' ? location.pathname.split('/')[index] : location.pathname.split('/').pop()
    if (popId && !isNaN(Number(popId))) setParamId(Number(popId))
  }

  useEffect(() => {
    handleParamId()
    return () => {
      setParamId(undefined)
    }
  }, [location])

  return paramId
}

export default useParamId
